import { useUserStore } from '../../store/useUserStore';
import { useNavigate } from 'react-router-dom';
import { useFavoriteVideosQuery } from '../../queries';
import ImgNoThumbnail from '../../assets/image/img_video_no_thumbnail.png';
import Url from '../../data/url';
import IcChevronRight from '../../assets/image/ic_chevron_right.svg';

function FavoriteVideos() {
  const navigate = useNavigate();
  const user = useUserStore();

  const { data: videos = [] } = useFavoriteVideosQuery(user.id as number, {
    enabled: !!user.id,
  });

  return (
    <>
      <div className="w-full flex items-center justify-between py-[16px] px-[20px]">
        <div className="text-[18px] font-[700] text-[#1C1C1C]">즐겨찾는 항목</div>
        <button
          type="button"
          className="flex items-center justify-center cursor-pointer"
          onClick={() => navigate(Url.HistoryFavoriteVideos)}
        >
          <div className="flex items-center text-[14px] font-[400] text-[#767676]">더보기</div>
          <img src={IcChevronRight} alt="더보기 아이콘" className="w-[16px] h-[16px] ml-[4px]" />
        </button>
      </div>
      <div className="flex items-center w-full justify-start overflow-x-auto min-h-[220px]">
        <div className="shrink-0 w-full inline-flex items-center justify-start gap-2 px-[20px] pb-2">
          {videos.length >= 1 ? (
            videos?.map((video, index) => (
              <button
                type="button"
                onClick={() =>
                  navigate(Url.HistoryWatchVideo, { state: { videos, videoIndex: index } })
                }
                key={video?.mediaId}
                className="shrink-0 w-[174px] h-[220px] bg-[#F8F8F8] rounded-[10px] flex items-center justify-center text-[#1C1C1C] text-[14px] font-[500]"
              >
                <img
                  src={video.thumbnailUrl || ImgNoThumbnail}
                  alt={`Video ${video.mediaId}`}
                  className="w-full h-full rounded-[10px]"
                />
              </button>
            ))
          ) : (
            <div className="w-full flex justify-center items-center text-[gray] text-center">
              즐겨찾기 비디오가 없습니다.
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default FavoriteVideos;
